import React from 'react'
import { useQuery } from '@apollo/client'
import { LazyLoadImage } from 'Blocks'
import { GET_CONTENTS, getArticlesCustomQueryVariables } from 'Queries'
import { path } from 'Utils'
import { Link } from 'react-router-dom'
import config from 'Config'

const TwinArticles = props => {
    const LoadURL = (type, uuid, slug) => {
        return path(type, { uuid, slug });
    }

    const twinArticlesData = {
        sb: {
            section: 'section-container-1140',
            tag: 'tag-blue',
            link: 'large-image-content-block-link'
        },
        hc: {
            section: 'section-container',
            tag: 'tag-orange',
            link: 'primary-link link-black'
        },
        us: {
            section: 'section-container',
            tag: 'tag-brown',
            link: 'primary-link'
        }
    }

    const LoadTwinArticles = () => {
        return (
            <div className="large-image-content-section">
                <div className={twinArticlesData[config.name].section}>
                    <div className="large-image-content-row">
                        {props.data.data.firstarticle.uuid !== '' &&
                            <div className="large-image-content-block" key={`twin-article-${props.data.data.firstarticle.uuid}`}>
                                <div className="large-image-content-image-holder">
                                    <Link to={LoadURL('article', props.data.data.firstarticle.uuid, props.data.data.firstarticle.slug)}>
                                        <div className={`content-tag ${twinArticlesData[config.name].tag}`}>{props.data.data.firstarticle.theme}</div>
                                        <LazyLoadImage
                                            alt={props.data.data.firstarticle.title}
                                            image={props.data.data.firstarticle.media}
                                            className="global-image"
                                            height={props.screenType === 'small' ? 350 : 610}
                                            width={props.screenType === 'small' ? 374 : 576}
                                            crop='crop'
                                        />
                                    </Link>
                                </div>
                                <div className="large-image-content-text-block">
                                    <div className="large-image-content-block-title">{props.data.data.firstarticle.title}</div>
                                    <div className="large-image-content-block-description">{props.data.data.firstarticle.description}</div>
                                    <div className="large-image-content-block-link-row">
                                    <Link to={LoadURL('article', props.data.data.firstarticle.uuid, props.data.data.firstarticle.slug)} className={twinArticlesData[config.name].link}>Read more</Link>
                                    </div>
                                </div>
                            </div>
                        }

                        {props.data.data.secondarticle.uuid !== '' &&
                            <div className="large-image-content-block" key={`twin-article-${props.data.data.secondarticle.uuid}`}>
                                <div className="large-image-content-image-holder">
                                    <Link to={props.data.data.secondarticle.affiliateURL !== '' ? props.data.data.secondarticle.affiliateURL : LoadURL('article', props.data.data.secondarticle.uuid, props.data.data.secondarticle.slug)} target={props.data.data.secondarticle.affiliateURL !== '' ? '_blank' : ''}>
                                    <div className={`content-tag ${twinArticlesData[config.name].tag}`}>{props.data.data.secondarticle.theme}</div>
                                    <LazyLoadImage
                                        alt={props.data.data.secondarticle.title}
                                        image={props.data.data.secondarticle.media}
                                        className="global-image"
                                        height={props.screenType === 'small' ? 350 : 610}
                                        width={props.screenType === 'small' ? 374 : 576}
                                        crop='crop'
                                    />
                                    </Link>
                                </div>
                                <div className="large-image-content-text-block">
                                    <div className="large-image-content-block-title">{props.data.data.secondarticle.title}</div>
                                    <div className="large-image-content-block-description">{props.data.data.secondarticle.description}</div>
                                    <div className="large-image-content-block-link-row">
                                        <Link to={props.data.data.secondarticle.affiliateURL !== '' ? props.data.data.secondarticle.affiliateURL : LoadURL('article', props.data.data.secondarticle.uuid, props.data.data.secondarticle.slug)} className={twinArticlesData[config.name].link} target={props.data.data.secondarticle.affiliateURL !== '' ? '_blank' : ''}>Read more</Link>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={props.className}>
            <LoadTwinArticles />
        </div>
    )
}

export default TwinArticles
